import Vue from 'vue'
import Worker from './../workers/upload.worker.js'
import uniqid from 'uniqid'

export default {
  namespaced: true,
  state: {
    items: [],
    labels: [],
    selectedLabel: localStorage.getItem('label') || null,
    page: Number(localStorage.getItem('page')) || 1,
    totalPages: 0,
    perPage: localStorage.getItem('perPage') || 5,
    activeEntity: null,
    search: localStorage.getItem('search') || null,
    filters: JSON.parse(localStorage.getItem('filters')) || ['eligibile ', 'partial eligibile ', 'posibil eligibile', 'Partial&Posibil Eligibile'],
    done: Number(localStorage.getItem('done')) || null,
    photos: Number(localStorage.getItem('photos')) || null,
    pdfs: Number(localStorage.getItem('pdfs')) || null,
    total: 0,
    files: {
      refs: [],
      total: 0,
      count: 0,
      done: 0,
      remaining: 0
    },
    worker: new Worker(),
    workerStop: true,
    progressOne: 0
  },
  getters: {
    items: state => state.items,
    labels: state => state.labels,
    selectedLabel: state => state.selectedLabel,
    total: state => state.total,
    page: state => state.page,
    totalPages: state => state.totalPages,
    perPage: state => state.perPage,
    activeEntity: state => state.activeEntity,
    search: state => state.search,
    filters: state => state.filters,
    done: state => state.done,
    photos: state => state.photos,
    pdfs: state => state.pdfs,
    files: state => state.files.refs,
    filesCount: state => state.files.count,
    filesSize: state => state.files.total,
    filesDone: state => state.files.done,
    workerStop: state => state.workerStop,
    progressOne: state => state.progressOne
  },
  mutations: {
    setItems (state, payload) {
      Vue.set(state, 'items', payload)
    },
    setTotal (state, payload) {
      Vue.set(state, 'total', payload)
    },
    setPage (state, payload) {
      state.page = payload
      localStorage.setItem('page', payload)
    },
    setPerPage (state, payload) {
      state.perPage = payload
      localStorage.setItem('perPage', payload)
    },
    setTotalPages (state, payload) {
      state.totalPages = payload
    },
    setActiveEntity (state, payload) {
      state.activeEntity = payload
    },
    saveItem (state, payload) {
      const stateIndex = state.items.findIndex(item => item._id === payload._id)
      Vue.set(state.items, stateIndex, payload)
    },
    setSearch (state, payload) {
      state.search = payload
      if (!payload) localStorage.removeItem('search', payload)
      else localStorage.setItem('search', payload)
    },
    setFilters (state, payload) {
      state.filters = payload
      localStorage.setItem('filters', JSON.stringify(payload))
    },
    setDone (state, payload) {
      state.done = payload
      if (!payload) localStorage.removeItem('done', payload)
      else localStorage.setItem('done', payload)
    },
    setPhotos (state, payload) {
      state.photos = payload
      if (!payload) localStorage.removeItem('photos', payload)
      else localStorage.setItem('photos', payload)
    },
    setPdfs (state, payload) {
      state.pdfs = payload
      if (!payload) localStorage.removeItem('pdfs', payload)
      else localStorage.setItem('pdfs', payload)
    },
    addPhotoEntity (state, payload) {
      if (state.activeEntity && state.activeEntity._id === payload.entity) {
        if (payload.tip === 'photo') {
          state.activeEntity.photos.push(payload.url)
        } else {
          state.activeEntity.pdfs.push(payload.url)
        }
      }
      const entityIndex = state.items.findIndex(item => item._id === payload.entity)
      if (entityIndex > -1) {
        if (state.activeEntity && state.activeEntity._id !== state.items[entityIndex]._id) {
          if (payload.tip === 'photo') {
            state.items[entityIndex].photos.push(payload.url)
          } else {
            state.items[entityIndex].pdfs.push(payload.url)
          }
        }
      }
    },
    setFilesStats (state, payload) {
      Vue.set(state.files, 'refs', payload.files)
      Vue.set(state.files, 'total', payload.total)
      Vue.set(state.files, 'done', payload.done)
      Vue.set(state.files, 'count', payload.count)
    },
    removeFile (state, file) {
      state.worker.postMessage({ type: 'remove', key: file.key })
    },
    incrementDone (state) {
      Vue.set(state.files, 'done', state.files.done + 1)
    },
    setWorkerStop (state, payload) {
      state.workerStop = payload
    },
    setLabels (state, payload) {
      Vue.set(state, 'labels', payload)
    },
    setSelectedLabel (state, payload) {
      state.selectedLabel = payload
      if (!payload) localStorage.removeItem('label', payload)
      else localStorage.setItem('label', payload)
    },
    setProgressOne (state, payload) {
      state.progressOne = payload
    }
  },
  actions: {
    uploadXLSX ({ rootState }, payload) {
      return rootState.services.xlsx.create(payload)
    },

    async fetchLabels ({ rootState, commit }) {
      const labels = await rootState.services.entities.find({ query: { $labels: true } })
      commit('setLabels', labels)
    },

    async fetchEntities ({ commit, dispatch, rootState, state }) {
      commit('setLoading', true, { root: true })

      await dispatch('fetchLabels')

      const query = {
        $limit: state.perPage,
        $skip: state.perPage * (state.page - 1),
        $sort: {
          simbol: 1
        }
      }

      if (state.search) {
        query.$search = state.search
      }

      if (state.filters.length) {
        query.$or = state.filters.map(f => {
          return {
            sheet: f
          }
        })
      }

      if (state.done !== null) {
        query.done = state.done === 1
      }

      if (state.photos !== null) {
        query.photos = state.photos === 1 ? { $ne: [] } : []
      }
      if (state.pdfs !== null) {
        query.pdfs = state.pdfs === 1 ? { $ne: [] } : []
      }

      if (state.selectedLabel) {
        query.eticheta = state.selectedLabel
      }

      rootState.services.entities.find({ query }).then(result => {
        commit('setTotalPages', Math.ceil(result.total / state.perPage))
        commit('setItems', result.data)
        commit('setTotal', result.total)
        // if (state.activeEntity) {
        //   const newActiveEntity = result.data.find(item => item._id === state.activeEntity._id)
        //   if (newActiveEntity) {
        //     commit('setActiveEntity', newActiveEntity)
        //   }
        // }
        commit('setLoading', false, { root: true })
      }).catch(error => {
        console.log(error)
        commit('setLoading', false, { root: true })
      })
    },
    fetchAllEntities ({ rootState, state }) {
      const query = {
        $paginate: false,
        $sort: {
          simbol: 1
        }
      }

      if (state.selectedLabel) {
        query.eticheta = state.selectedLabel
      }

      return rootState.services.entities.find({ query })
    },

    search ({ commit, dispatch }, payload) {
      commit('setSearch', payload)
      dispatch('fetchEntities')
    },
    setPage ({ commit, dispatch }, payload) {
      commit('setLoading', true, { root: true })
      commit('setPage', payload)
      commit('setLoading', false, { root: true })

      dispatch('fetchEntities')
    },
    setPerPage ({ commit, dispatch }, payload) {
      commit('setLoading', true, { root: true })
      commit('setPerPage', payload)
      commit('setLoading', false, { root: true })

      dispatch('fetchEntities')
    },
    setActiveEntity ({ rootState, commit }, payload) {
      if (payload) {
        commit('setLoading', true, { root: true })

        rootState.services.entities.get(payload).then(result => {
          commit('setActiveEntity', result)
          commit('setLoading', false, { root: true })
        }).catch(error => {
          console.log(error)
          commit('setLoading', false, { root: true })
        })

        commit('setLoading', false, { root: true })
      }
    },
    save ({ commit, rootState, state }, payload) {
      commit('setLoading', true, { root: true })

      rootState.services.entities.update(payload._id, payload).then(result => {
        if (state.activeEntity._id === result._id) {
          commit('setActiveEntity', result)
        }
        commit('setLoading', false, { root: true })
      }).catch(error => {
        console.log(error)
        commit('setLoading', false, { root: true })
      })

      // commit('saveItem', payload)
      commit('setLoading', false, { root: true })
    },

    setupWorker ({ rootState, state, commit, dispatch }) {
      state.worker.postMessage('init')
      state.worker.onmessage = m => {
        if (m.data.type === 'done') {
          commit('setLoading', false, { root: true })
          commit('setWorkerStop', true)
          commit('setFilesStats', {
            files: [],
            done: 0,
            total: 0,
            count: 0
          })
          dispatch('fetchEntities')
          commit('setProgressOne', 0)
        } else if (m.data.type === 'done with remaining') {
          commit('setLoading', false, { root: true })
          commit('setWorkerStop', true)
          commit('setProgressOne', 0)
        } else if (m.data.type === 'read') {
          const result = m.data
          if (result) {
            commit('setFilesStats', result)
          }
        } else if (m.data.type === 'uploaded-one') {
          commit('addPhotoEntity', m.data.file)
          commit('incrementDone')
          commit('saveMessage', {
            id: uniqid(),
            text: m.data.file.name,
            tip: m.data.file.tip,
            type: 'success',
            timestamp: new Date()
          }, { root: true })
          dispatch('fetchEntities')
        } else if (m.data.type === 'progress-one') {
          commit('setProgressOne', m.data.progress)
        } else if (m.data.type === 'failed-one') {
          commit('saveMessage', {
            id: uniqid(),
            text: m.data.file.name,
            tip: m.data.file.tip,
            type: 'fail',
            timestamp: new Date()
          }, { root: true })
          // if (!rootState.messagesOpen) {
          //   commit('setMessagesOpen', true, { root: true })
          // }
        } else if (m.data.type === 'uploaded-test') {
          commit('saveMessage', {
            id: uniqid(),
            text: m.data.file.name,
            tip: m.data.file.tip,
            type: 'success',
            timestamp: new Date()
          }, { root: true })
          if (!rootState.messagesOpen) {
            commit('setMessagesOpen', true, { root: true })
          }
        } else if (m.data.type === 'failed-test') {
          commit('saveMessage', {
            id: uniqid(),
            text: m.data.file.name,
            tip: m.data.file.tip,
            type: 'fail',
            timestamp: new Date()
          }, { root: true })
          if (!rootState.messagesOpen) {
            commit('setMessagesOpen', true, { root: true })
          }
        }
      }
    },
    sendUserToWorker ({ rootState, state }) {
      state.worker.postMessage({ type: 'setUserAndToken', token: rootState.auth.token, user: rootState.auth.user._id })
    },
    addFiles ({ state, rootState, commit, dispatch }, payload) {
      dispatch('setOnlineOfflineHandler', null, { root: true })

      const files = payload.files.map((f, i) => {
        return {
          ref: f,
          entity: payload.entity,
          tip: payload.tip
        }
      })

      state.worker.postMessage({ type: 'add', files })
    },
    deletePhotos ({ dispatch, commit, rootState }, payload) {
      if (payload.photos.length) {
        commit('setLoading', true, { root: true })
        // payload.entity -> entity._id
        // payload.photos -> array of urls; /photos/entityid_userid_timestamp.extension

        payload.photos.forEach(photo => {
          rootState.services.photos.remove(null, {
            query: {
              url: photo
            }
          })
            .then(result => {
              if (payload.entity) {
                dispatch('setActiveEntity', payload.entity)
                commit('setLoading', false, { root: true })
              }
            })
            .catch(err => {
              console.log(err)
              commit('setLoading', false, { root: true })
            })
        })
      }
    },

    toggleFilter ({ commit, state, dispatch }, payload) {
      let filters
      if (state.filters.includes(payload)) {
        filters = state.filters.filter(f => f !== payload)
      } else {
        filters = state.filters.map(f => f)
        filters.push(payload)
      }

      if (!filters.length) {
        filters = ['eligibile ', 'partial eligibile ', 'posibil eligibile', 'Partial&Posibil Eligibile']
      }

      commit('setFilters', filters)
      dispatch('fetchEntities')
    },

    toggleDone ({ commit, state, dispatch }) {
      if (state.done === null) { // all
        commit('setDone', 1)
      } else if (state.done === 1) { // done
        commit('setDone', -1)
      } else { // not done
        commit('setDone', null)
      }
      dispatch('fetchEntities')
    },
    togglePhotos ({ commit, state, dispatch }) {
      if (state.photos === null) { // all
        commit('setPhotos', 1)
      } else if (state.photos === 1) { // Photos
        commit('setPhotos', -1)
      } else { // no Photos
        commit('setPhotos', null)
      }
      dispatch('fetchEntities')
    },
    togglePdfs ({ commit, state, dispatch }) {
      if (state.pdfs === null) { // all
        commit('setPdfs', 1)
      } else if (state.pdfs === 1) { // Pdfs
        commit('setPdfs', -1)
      } else { // no Pdfs
        commit('setPdfs', null)
      }
      dispatch('fetchEntities')
    },
    uploadPhotos ({ commit, rootState, state }) {
      commit('setLoading', true, { root: true })

      commit('setWorkerStop', false)
      state.worker.postMessage({ type: 'upload' })
    },

    pauseUpload ({ state, commit }) {
      commit('setWorkerStop', true)
      state.worker.postMessage({ type: 'stop' })
    },
    resumeUpload ({ state, commit }) {
      commit('setWorkerStop', false)
      state.worker.postMessage({ type: 'resume' })
    },

    saveEditedPhoto ({ rootState, dispatch }, payload) {
      dispatch('deletePhotos', { photos: [payload.photo] })
      return rootState.services.photos.create({
        buffer: payload.newImage,
        entity: payload.id,
        user: rootState.auth.user._id
      }).then(result => {
        return rootState.services.entities.get(result.entity)
      })
      // return fetch(`${rootState.serverURL}/rest-savePhoto`, {
      //   method: 'post',
      //   headers: new Headers({
      //     'Authorization': rootState.auth.token,
      //     'Content-Type': 'application/json'
      //   }),
      //   body: JSON.stringify(payload)
      // })
    },
    async deleteEntities ({ rootState, dispatch, commit }, payload) {
      commit('setLoading', true, { root: true })
      for (const id of payload) {
        try {
          await rootState.services.entities.remove(id)
        } catch (err) {
          console.log(err)
        }
      }
      commit('setLoading', false, { root: true })
      dispatch('fetchEntities')
    },
    deletePdfs ({ dispatch, commit, rootState }, payload) {
      if (payload.pdfs.length) {
        commit('setLoading', true, { root: true })
        // payload.entity -> entity._id
        // payload.photos -> array of urls; /photos/entityid_userid_timestamp.extension

        payload.pdfs.forEach(pdf => {
          rootState.services.pdfs.remove(null, {
            query: {
              url: pdf
            }
          })
            .then(result => {
              if (payload.entity) {
                dispatch('setActiveEntity', payload.entity)
                commit('setLoading', false, { root: true })
              }
            })
            .catch(err => {
              console.log(err)
              commit('setLoading', false, { root: true })
            })
        })
      }
    }
  }
}
